export const COLLABORATION_CONSTS = {
  FE_ID: 'FE_ID',
  context: 'context',
  topic: 'topic',
  upload: 'upload'
};
